
import React from 'react';
import { motion } from 'framer-motion';
import { SizeOption } from './types';
import { Ruler } from 'lucide-react';

interface SizeInfoDisplayProps {
  hoveredSizeInfo: SizeOption | undefined;
  gender: 'male' | 'female';
}

const SizeInfoDisplay: React.FC<SizeInfoDisplayProps> = ({ hoveredSizeInfo, gender }) => {
  // If no size info is available, show a placeholder message
  if (!hoveredSizeInfo) {
    return (
      <motion.div 
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        className={`
          p-4 rounded-lg shadow-md border border-gray-200 bg-gray-50
          text-center text-gray-500
        `}
      >
        <p className="text-sm font-medium flex items-center justify-center">
          <Ruler className="w-4 h-4 mr-2" />
          Vui lòng chọn kích thước áo để xem thông tin chi tiết
        </p>
      </motion.div>
    );
  }
  
  return (
    <motion.div 
      key={`${gender}-${hoveredSizeInfo.value}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className={`
        p-4 rounded-lg shadow-md border 
        ${gender === 'male' ? 'bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200' : 'bg-gradient-to-br from-pink-50 to-rose-50 border-pink-200'}
        text-center
      `}
    >
      <p className={`text-sm ${gender === 'male' ? 'text-blue-700' : 'text-pink-700'} font-medium`}>
        <span className="font-bold text-base">{hoveredSizeInfo.value}</span>: 
        Rộng <span className="font-semibold">{hoveredSizeInfo.width}cm</span> × 
        Dài <span className="font-semibold">{hoveredSizeInfo.length}cm</span>
      </p>
    </motion.div>
  );
};

export default SizeInfoDisplay;
